import { AGENCY_VIEW } from '../components/search-filter-bar/enums';

const isAgencyView = (
  option: 'real-estate-agencies' | 'real-estate-agents',
): boolean => option === AGENCY_VIEW;

export default isAgencyView;
